var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTabs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.011 18.011V6.986C5.011 6.436 5.211 5.96933 5.611 5.586C6.011 5.20267 6.486 5.011 7.036 5.011H18.011C18.561 5.011 19.0318 5.20683 19.4235 5.5985C19.8152 5.99017 20.011 6.461 20.011 7.011V15.011L15.011 20.011H7.011C6.461 20.011 5.99017 19.8152 5.5985 19.4235C5.20683 19.0318 5.011 18.561 5.011 18.011ZM0.036 4.261C-0.064 3.711 0.0443333 3.21517 0.361 2.7735C0.677667 2.33183 1.111 2.061 1.661 1.961L12.511 0.036C13.061 -0.064 13.5568 0.0443333 13.9985 0.361C14.4402 0.677667 14.711 1.111 14.811 1.661L15.061 3.011H13.011L12.836 2.011L2.011 3.936L3.011 9.586V16.561C2.74433 16.411 2.51517 16.211 2.3235 15.961C2.13183 15.711 2.011 15.4277 1.961 15.111L0.036 4.261ZM7.011 7.011V18.011H14.011L18.011 14.011V7.011H7.011ZM11.511 16.511H13.511V13.511H16.511V11.511H13.511V8.511H11.511V11.511H8.511V13.511H11.511V16.511Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTabs);
export default __webpack_public_path__ + "static/media/add_tabs.b55191fa892ca95c9233e66fda268226.svg";
export { ForwardRef as ReactComponent };